<template>
  <div
    v-bind:class="{ 'addExcel': showHelp}"
    class="custom-progress-bar complete"
    v-if="progressStatus"
  >
    <div style="padding: 10px 15px 15px;display: flex;">
      <div style="display: inline-flex;color: #00ab48;font-size: 16px;font-weight: 500;width:95%">
        <div
          class="on"
          v-bind:class="{ 'addExcelProgress': !showHelp}"
          v-if="percentage < 100"
          style="display: inline-flex;width:100%;"
        >
          <div class="progress-bar-loader">
            <svg viewBox="0 0 64 64">
              <g stroke-width="0">
                <circle cx="24" cy="0" transform="translate(32,32)" r="6.63154">
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="8;7;6;5;4;3;2;1;8"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="16.970562748477143"
                  cy="16.97056274847714"
                  transform="translate(32,32)"
                  r="7.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="1;8;7;6;5;4;3;2;1"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="1.4695761589768238e-15"
                  cy="24"
                  transform="translate(32,32)"
                  r="3.57921"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="2;1;8;7;6;5;4;3;2"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="-16.97056274847714"
                  cy="16.970562748477143"
                  transform="translate(32,32)"
                  r="3.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="3;2;1;8;7;6;5;4;3"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="-24"
                  cy="2.9391523179536475e-15"
                  transform="translate(32,32)"
                  r="3.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="4;3;2;1;8;7;6;5;4"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="-16.970562748477143"
                  cy="-16.97056274847714"
                  transform="translate(32,32)"
                  r="3.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="5;4;3;2;1;8;7;6;5"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="-4.408728476930472e-15"
                  cy="-24"
                  transform="translate(32,32)"
                  r="4.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="6;5;4;3;2;1;8;7;6"
                    repeatCount="indefinite"
                  />
                </circle>
                <circle
                  cx="16.970562748477136"
                  cy="-16.970562748477143"
                  transform="translate(32,32)"
                  r="5.63154"
                >
                  <animate
                    attributeName="r"
                    dur="800ms"
                    values="7;6;5;4;3;2;1;8;7"
                    repeatCount="indefinite"
                  />
                </circle>
              </g>
            </svg>
          </div>
          <div style="font-size:13px;">{{progressTitleStatus | capatalize}}ing {{progressTitle}}..</div>
          <div
            style="float: right;width: 49%;text-align: right;font-size: 13px;font-weight: normal;"
          >
            <span>{{percentage}}% completed</span>
          </div>
        </div>
        <div v-if="percentage == 100 && showHelp" style="font-size:13px;">
          Your file was successfully downloaded. If you have trouble opening the file, please go to
          <a style="cursor:pointer" v-on:click="help">"Help"</a> and click "Records" and then "Export Records"
        </div>
        <div
          class
          v-bind:class="{ 'addExcelProgresstatus': !showHelp}"
          v-if="percentage == 100 && !showHelp"
          style="font-size:13px;margin-top: 6%;"
        >{{progressTitle | capatalize}} {{progressTitleStatus}}ed</div>
      </div>
      <div style="display: inline; float: right;font-size: 13px;color: rgb(134, 134, 134);">
        <span v-if="percentage == 100">
          <button type="button" class="close" @click="closeProgressBar">
            <i class="fa fa-times"></i>
          </button>
        </span>
      </div>
    </div>
    <div class="bar-container">
      <div class="bar" v-bind:style="{ 'width' : percentage + '%' }"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progressStatus: Boolean,
    percentage: Number,
    progressTitle: String,
    progressTitleStatus: String,
    showHelp: Boolean,
  },
  data() {
    return {};
  },
  filters: {
    capatalize(value) {
      return value[0].toUpperCase() + value.slice(1);
    },
  },
  computed: {
    complete() {
      return {
        complete: this.percentage === 100,
      };
    },
  },
  watch: {
    percentage() {
      if (this.percentage === 100) {
        setTimeout(() => {
          // this.$emit('updateProgressStatus');
        }, 5000);
      }
    },
  },
  methods: {
    closeProgressBar() {
      this.$emit('updateProgressStatus');
    },
    help() {
      this.$emit('updateProgressStatus');
    },
  },
};
</script>
<style scoped>
.on.addExcelProgress {
  padding-top: 0px !important;
}
.addExcelProgresstatus {
  margin-top: 0 !important;
}
</style>
